<template>
  <div class="c-siteMenuOverlay" :class="[{ 'is-open': isOpen }, { 'is-closed': !isOpen }, menuClass]">

      <div
        class="c-siteMenuOverlay__background"
        @click="close"
        v-if="isOpen"
      ></div>

	<div class="c-siteMenuOverlay__inner" :class="placementClass">
		<div class="c-siteMenuOverlay__inner__port">
			<div class="c-siteMenuOverlay__inner__port__text">
				<p>Business areas - Port esbjerg</p>
			</div>
		</div>
		<div class="c-siteMenuOverlay__content">
			<div class="c-siteMenuOverlay__content__header">
				<div class="c-siteMenuOverlay__content__header__close" v-if="isOpen" @click="close">
					<iClose />
				</div>
			</div>
			<div class="c-siteMenuOverlay__content__body customscroll">
				<ul>
					<li v-for="nav in navigation" :key="nav.id"  >
						<!-- <a :href="nav.url" :class="{'current' : nav.current}" @click.prevent="navigate(nav.name, 'fade')">{{ nav.title }}</a> -->
						<a :href="nav.url" :class="{'current' : nav.current}">{{ nav.title }}</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import iClose from '@/assets/icon/close.svg';


export default {
  name: "SiteMenuOverlay",
  components: {
	  iClose
  },

	data: () => ({
		menuClass: '',
    }),

  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    placement: {
      type: String,
      default: "right",
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
	navigation: Object,
  },
  computed: {
    ...mapState({
      translations: (state) => state.app.translations,
    }),
    placementClass() {
      return "c-siteMenuOverlay__inner" + "--" + this.placement;
    },
  },
  methods: {
    close() {
		this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/abstracts/variables.scss";

.c-siteMenuOverlay {
  position: relative;
  z-index: 20;

  &__background {
    // background-color: $c-overlay;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 20;
  }

  &__inner {
	transition: $t-nice;
    display: flex;
    max-height: 100%;
    position: fixed;
    z-index: 20;
    top: 0;
    bottom: 0;
    opacity: 0;
	width: 100%;
    background-color: $brand-white;
    bottom: 0;
    transition: transform 500ms $t-nice, opacity 300ms $t-nice 500ms;

	&__port{
		width: 80px;
		max-width: 80px;
		min-width: 80px;
		height: 100vh;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-right: 1px solid #EBEDEF;
		border-left: 1px solid #EBEDEF;

		&__text{
			display: flex;
			flex-grow: 1;
			p{
				writing-mode: vertical-lr;
				text-orientation: mixed;
				transform: rotate(180deg);
				text-transform: uppercase;

				font-size: 11px;
				letter-spacing: 2.5px;
				text-align: center;
				color: #817A74;
			}
		}
	}

    &--left {
      left: 0;
      transform: translate(-100%, 0);
    }

    &--right {
      right: 0;
      transform: translate(calc(100% - 79px), 0);
	  pointer-events: none;
    }

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
	  pointer-events: all;
	  transition: transform 500ms $t-nice, opacity 00ms $t-nice 0ms;
    }
  }

  	&__content{
		padding-left: 30px;
		padding-right: 30px;
		width: 100%;
		padding-top: 57px;

		&__header{
			height: 35px;
			// margin-bottom: 30px;
			display: flex;
			justify-content: flex-end;

			&__close{
				position: fixed;
				top: 50px;
				right: 26px;
				svg{
					.fill{
						transition: $t-hover;
						fill: $brand-blue;
					}
					width: 28px;
				}
				&:hover{
					cursor: pointer;
					svg{
						.fill{
							transition: $t-hover;
							fill: rgba($brand-blue, .6);
						}

					}
				}
			}
		}

		&__body{
			width: 100%;
			height: calc(100% - 130px);
			padding-left: 100px;
			// height: 100%;
			overflow-y: scroll;
    		overflow-x: hidden;
			display: flex;
			align-items: center;
			// justify-content: center;
			// padding-bottom: 125px;
			// padding-top: 30%;

			ul{
				li{
					opacity: 0;
					margin: 30px 0;
					transform: translateX(20px);
					transition: all 0.4s;

					font-size: 35px;
					line-height: 35px;
					color: #2E384B;
					font-weight: $f-bold;
					cursor: pointer;


					.is-closed & {

						transition: all 0.4s;

						$time-offset-close: 0;
						@for $i from 1 through 10 {
							&:nth-child(#{$i}) {
								$time-offset-close: $time-offset-close + 0.1;
								transition-delay: #{$time-offset-close}s;
								span {
									transition-delay: #{$time-offset-close}s;
								}
							}
						}
					}

					.is-open & {
						opacity: 1;
						transform: translateX(0);
						backface-visibility: hidden;
						$time-offset-open: 0.4;
						@for $i from 1 through 10 {
							&:nth-child(#{$i}) {
								$time-offset-open: $time-offset-open + 0.1;
								transition-delay: #{$time-offset-open}s;
								span {
									transition-delay: #{$time-offset-open}s;
								}
							}
						}
					}

					// &.selected{
					// 	a:before{
					// 		width: 15px;
					// 	}
					// }
				}
				.current{
					color: rgba($color: #2E384B, $alpha: .3);
				}
			}

		}
  	}

  &.is-open {
    .c-siteMenuOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}

@media all and (max-width: 768px) {
	.c-siteMenuOverlay {
		position: relative;

		&__content{
			padding-top: 30px;

			&__body{
				justify-content: center;
				padding-left: 30px;
				padding-right: 30px;

				ul{
					li{
						margin: 25px 0;
						font-size: 28px;
						line-height: 28px;
					}
				}
			}
		}
	}
}

@media all and (max-width: 500px) {
	.c-siteMenuOverlay{
		&__inner{
			&--right{
				transform: translate(100%, 0);
			}
		}
		&__content{
			&__header{
				&__close{
					top: 30px;
					right: 20px;
					width: 36px;
					height: 36px;
					border: 1px solid #EBEDEF;
					border-radius: 50%;

					display: flex;
					align-items: center;
					justify-content: center;

					transition: $t-hover;
					svg{
						width: 10px;
					}

					&:hover{
						transition: $t-hover;
						cursor: pointer;

						svg{
							.fill{
								fill: $brand-blue;
							}

						}
						background-color: darken($color: $brand-white, $amount: 10)
					}
				}
			}

			&__body{
				justify-content: center;
				padding-left: 15px;
				padding-right: 15px;

				ul{
					li{
						margin: 22px 0;
						font-size: 22px;
						line-height: 22px;
					}
				}
			}
		}
	}
}

</style>
